import { createBrowserRouter, Navigate, RouterProvider } from "react-router"

import { EnkAuthProvider } from "./auth/auth-provider"
import EnkDashboard from "./pages/dashboard"

import EnkErrorPage from "./pages/error-page"
import EnkLayout from "./layouts/layout"
import EnkLogin from "./pages/login"

import EnkProtectedRoute from "./auth/protected-route"
import EnkCalendar from "./pages/calendar"
import EnkProfilePage from "./pages/profile-page"
import EnkMsgDialogProvider from "./dialogs/msgdialog-provider"
import EnkReports from "./pages/reports"
import EnkShowReports from "./pages/show-report"
import EnkNotificationsPage from "./pages/notifications"
import EnkResetPassword from "./pages/reset-password"
import EnkDocuments from "./pages/documents"

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <EnkProtectedRoute>
        <EnkLayout />
      </EnkProtectedRoute>
    ),
    errorElement: <EnkErrorPage />,
    children: [
      { index: true, element: <Navigate to="/dashboard" /> },
      { path: "/dashboard", element: <EnkDashboard /> },
      { path: "/calendar", element: <EnkCalendar /> },
      { path: "/documents", element: <EnkDocuments /> },
      { path: "/reports", element: <EnkReports /> },
      { path: "/report/:reportName", element: <EnkShowReports /> },
      { path: "/notifications", element: <EnkNotificationsPage /> },
      { path: "/profile", element: <EnkProfilePage /> },
    ],
  },
  { path: "/login", element: <EnkLogin />, errorElement: <EnkErrorPage /> },
  { path: "/resetpassword", element: <EnkResetPassword />, errorElement: <EnkErrorPage /> },
])

export default function MyRoutes() {
  return (
    <EnkMsgDialogProvider>
      <EnkAuthProvider>
        <RouterProvider router={router} />
      </EnkAuthProvider>
    </EnkMsgDialogProvider>
  )
}
